// Third-party library imports.
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

// Local repo imports.
import { CheckboxPaletteContext } from '../CheckboxPalette.context';
import { EMPTY_ARRAY, NO_OP } from '../../../constants/Constants';
import '../CheckboxPalette.scss';
class PaletteAction extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.getActionLabel = type => {
      const {
        paletteActions
      } = this.context;
      let actionLabel = '';
      paletteActions.some(actionConfig => {
        const {
          key,
          label
        } = actionConfig;
        if (key === type) {
          actionLabel = label;
          return true;
        }
        return false;
      });
      return actionLabel;
    };
    this.handleCheckboxChange = e => {
      e.stopPropagation();
      const {
        onClickAction
      } = this.props;
      const value = e.target.checked;
      const {
        type
      } = e.target['data-action'];
      onClickAction({
        type,
        value
      });
    };
  }
  render() {
    const {
      actions,
      displayActionLabel
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "palette-actions"
    }, actions.map(action => /*#__PURE__*/React.createElement("span", {
      className: "palette-action-checkbox palette-words-overflow-control"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      key: action.type,
      checked: action.value,
      disabled: action.disabled,
      "data-action": action,
      onChange: this.handleCheckboxChange
    }), displayActionLabel && /*#__PURE__*/React.createElement("span", {
      className: "palette-header palette-words-overflow-control"
    }, this.getActionLabel(action.type)))));
  }
}
PaletteAction.contextType = CheckboxPaletteContext;
PaletteAction.propTypes = {
  actions: PropTypes.array,
  displayActionLabel: PropTypes.bool,
  onClickAction: PropTypes.func
};
PaletteAction.defaultProps = {
  actions: EMPTY_ARRAY,
  displayActionLabel: false,
  onClickAction: NO_OP
};
export default PaletteAction;